import { HStack, VStack } from 'reaction';
import ProjectSection from 'components/portfolio/sections/ProjectSection';
import './RealTimeChess.css';
import background from 'assets/portfolio/check-mate.jpg';
import CTAButtonGroup from './CTAButtonGroup';

export default function RealTimeChess() {
    return (
        <ProjectSection
            image='https://raw.githubusercontent.com/Capstone-Projects-2022-Spring/project-real-time-chess/master/static/public/img/RTC-Logo.png'
            imageAlt={'RealTime Chess Logo'}
            details='right'
            backgroundImage={background}
            shade='dark'>
            <h2>Real Time Chess</h2>
            <p>
                Real Time Chess (RTC) was my capstone project. I worked with six other group members
                to develop this application. As the project leader, I put 4 months of hard work into
                this application. And I am still working on it today.
            </p>
            <CTAButtonGroup />
        </ProjectSection>
    );
}
